import React, { useRef } from 'react';
import styled from 'styled-components';
import WaveDivider from './WaveDivider';
import { useSurroundingColors } from '@client/modules/shared/UseSurroundingColors';

const StyledDivider = styled(WaveDivider)`
	box-sizing: content-box;
	padding-top: var(--breaker-padding);
	margin-top: calc(var(--breaker-total) * -1);
	margin-bottom: -1.5px;
	position: relative;
	z-index: 1;
`;

export default function AutoDivider() {
	const moduleRef = useRef<SVGSVGElement | null>(null);
	const colors = useSurroundingColors(moduleRef);

	return <StyledDivider ref={moduleRef} className='BreakerModule' fg={colors[1]} />;
}
